export default {
    // https://noodzly.com/app/home
    app: {
        home: {
            subscribed: "Suscrito",
            following: "Siguiendo",
            discover: "Descubrir",
        },
    },
    user: {
        setting: {
            main: {
                // https://noodzly.com/user/setting/main
                title: "Configuración",
                delete_account: "Eliminar Cuenta",
                logout: "Cerrar Sesión",
            },
            language: {
                // https://noodzly.com/user/setting/language
                title: "Idioma",
                button: "Listo",
            },
            password: {
                // https://noodzly.com/user/setting/password
                title: "Contraseña",
                old_password: " Vieja Contraseña",
                new_password: "Nueva Contraseña",
                confirm_password: "Confirmar Contraseña",
                update: "Actualizar",
            },
            email: {
                // https://noodzly.com/user/setting/email
                title: "Correo Electrónico",
                email: "Correo Electrónico",
                example: "ejemplo@ejemplo.com",
                update: "Actualizar",
            },
            // https://noodzly.com/user/setting/notification
            notification: {
                title: "Notificaciones",
                app: "App",
                follow: "Seguir",
                new_subscriber: "Nuevo Suscriptor",
                messages: "Mensajes",
                email: "Correo Electrónico",
                fund_sent: "Fondo Enviado",
                tips_received: "Propinas Recibidas",
                save: "Guardar",
            },
            // https://noodzly.com/user/setting/main
            blacklist: {
                title: "Usuarios Bloqueados",
            },
            // https://noodzly.com/user/setting/block-regions
            block_regions: {
                title: "Bloquear Regiones",
            },
            // https://noodzly.com/user/setting/sessions
            sessions: {
                title: "Sesiones",
                something_went_wrong: "¿Algo salió mal?",
                change_your_password: "Cambiar tu Contraseña",
                device: "Dispositivo",
                browser: "Navegador",
                date: "Fecha",
            },
            // https://noodzly.com/user/setting/contact
            contact: {
                title: "Contáctanos",
                placeholder: "¿Qué pasa?",
                send: "Enviar",
                sent: "Enviado",
                type_label: "¿Qué te trae por aquí?",
            },
            //https://noodzly.com/user/setting/creator
            creator: {
                title: "Noodzler",
                verify: {
                    title: "Verificar Cuenta",
                },
                agreement: {
                    title: "Contrato de Acuerdo",
                    sub_title: "ACUERDO ESTÁNDAR ENTRE NOODZLY Y NOODZLER",
                    field: {
                        name: "Nombre",
                    },
                    btn: {
                        accept: "Aceptar",
                    },
                },
                // https://noodzly.com/user/setting/creator/verify-ondato
                verify_ondato: {
                    title: "Verifique su cuenta",
                    verify_account: "Cuentas verificadas",
                    action_link: "comenzar la verificación",
                    add_another_model: "Agregar otra cuenta",
                    model_has_verified: "{name} ha sido verificada en",
                    model_not_verified: "Noodzler {name} no está verificado",
                    status_created: " ",
                    status_processed: "procesado",
                    status_resolved: "resuelto",
                    status_rejected: "rechazado",
                    reverify_button: "Volver a verificar",
                    model_verification_expired: 'El documento de {name} ha caducado. Vuelva a verificarlo para continuar.',
                    remove_verification: 'Eliminar',
                },
                withdraw_options: {
                    title: "Opciones de Retiro",
                    withdraw: {
                        title: "Retiro",
                        bank_transfer: {
                            title: "Transferencia Bancaria",
                            swift_code: "Código SWIFT",
                            placeholder_swift_code: "Insertar Código SWIFT",
                            iban_number: "Código IBAN",
                            placeholder_iban_number: "Insertar Código IBAN",
                            bank_name: "Nombre del Banco",
                            placeholder_bank_name: "Escribir Nombre del Banco",
                            bank_country: "País del Banco",
                            placeholder_bank_country: "País",
                            convert_currency: "Convertiremos USD a EUR el día del pago mediante {ecb_rate_link}",
                            note_1: "Tiempo para recibir el pago: Las transferencias Sepa y Swift se procesan DIARIAMENTE (de lunes a viernes). Los fondos solicitados antes de las 23:59 EST se procesarán al siguiente día hábil. Por favor, permite un tiempo adicional de 5 a 7 días hábiles para que los fondos se depositen en tu cuenta.",
                            note_2: "NOTA: Tu banco (o el banco intermediario) puede cobrarte tarifas además de las tarifas. Las tarifas cobradas por tu banco (o el banco intermediario) no están bajo nuestro control. Consulta con tu banco antes de solicitar un pago si no estás seguro.",
                            beneficiary_name: 'Nombre del beneficiario',
                            placeholder_beneficiary_name: 'Insertar nombre del beneficiario',
                            beneficiary_street: 'Calle del Beneficiario',
                            placeholder_beneficiary_street: 'Insertar calle del beneficiario',
                            beneficiary_city: 'Ciudad beneficiaria',
                            placeholder_beneficiary_city: 'Insertar ciudad beneficiaria',
                            beneficiary_country: 'País Beneficiario',
                            placeholder_beneficiary_country: 'Insertar país beneficiario',
                            beneficiary_state: 'Estado beneficiario',
                            placeholder_beneficiary_state: 'Insertar Estado Beneficiario',
                            beneficiary_zip: 'Código postal del beneficiario',
                            placeholder_beneficiary_zip: 'Insertar código postal del beneficiario',
                        },
                        bitsafe: {
                            title: "Yoursafe",
                            full_name: "Nombre Completo del Beneficiario",
                            iban: "Yoursafe IBAN",
                            country: "País",
                        },
                        wire_transfer: {
                            title: "Transferencia bancaria internacional",
                            swift_code: "Código SWIFT",
                            placeholder_swift_code: "Insertar Código SWIFT",
                            iban_number: "Código IBAN",
                            placeholder_iban_number: "Insertar Código IBAN",
                            bank_name: "Nombre del Banco",
                            placeholder_bank_name: "Escribir Nombre del Banco",
                            bank_country: "País del Banco",
                            placeholder_bank_country: "País",
                            convert_currency: "We will convert USD to EUR on the day of payment by {ecb_rate_link}",
                            note_1: "Time to receive payment: Sepa & Swift payments are now processed DAILY (Monday - Friday). Funds requested prior to 23:59 EST will be processed the following business day. Please allow an additional 5 - 7 business days for the funds to settle in your account.",
                            note_2: "NOTE: Your bank (or intermediary bank) may charge you fees in addition to the fees. Fees charged by your bank (or intermediary bank) are not under our control. Please consult with your bank prior to requesting a payment if you are unsure.",
                            beneficiary_name: 'Nombre del beneficiario',
                            placeholder_beneficiary_name: 'Insertar nombre del beneficiario',
                            beneficiary_street: 'Calle del Beneficiario',
                            placeholder_beneficiary_street: 'Insertar calle del beneficiario',
                            beneficiary_city: 'Ciudad beneficiaria',
                            placeholder_beneficiary_city: 'Insertar ciudad beneficiaria',
                            beneficiary_country: 'País Beneficiario',
                            placeholder_beneficiary_country: 'Insertar país beneficiario',
                            beneficiary_state: 'Estado beneficiario',
                            placeholder_beneficiary_state: 'Insertar Estado Beneficiario',
                            beneficiary_zip: 'Código postal del beneficiario',
                            placeholder_beneficiary_zip: 'Insertar código postal del beneficiario',
                        },
                        crypto_wallet: {
                            title: "Cripto",
                            wallet_address: "Dirección de la billetera criptográfica",
                            placeholder_wallet_address: "Insertar la dirección de la billetera criptográfica",
                            crypto_currency: "Criptomoneda",
                            placeholder_crypto_currency: "Seleccione Criptomoneda",
                            country: "País",
                            placeholder_country: "Seleccione país",
                        },
                    },
                },
                // https://noodzly.com/user/setting/creator/streams
                streams: {
                    title: "Transmisiones Privadas",
                    tabs: {
                        now: "Ahora",
                        later: "Programar",
                    },
                    fields: {
                        price: {
                            title: "Precio",
                        },
                        ticketsSold: {
                            title: "Entradas Vendidas",
                        },
                        viewersLimit: {
                            title: "Límite de Espectadores",
                        },
                        dateTime: {
                            title: "Comienza a las",
                        },
                        isFreeForSubscribers: {
                            title: "Gratis para suscriptores",
                        },
                        rating: {
                            title: "Puntuación de tus transmisiones",
                        },
                        isFreeForFollowers: {
                            title: "Gratis para seguidores",
                        },
                        setGoal: {
                            title: "Establecer una meta",
                        },
                    },
                    actions: {
                        schedule: "Programar",
                        save: "Guardar",
                        goLive: "Ir en Directo",
                    },
                    rules: {
                        title: "Al utilizar programas en vivo, aceptas nuestras ",
                        name: "reglas de flujo",
                    },
                },
                stream: {
                    title: "Transmisión Privada",
                    streamIsNotLive: "La transmisión aún no está en vivo",
                    messages: {
                        system: {
                            joined: "se unió",
                        },
                    },
                    liveReport: {
                        title: "Informe en Vivo",
                        totalTips: "Total de Propinas Recibidas",
                        totalTickets: "Total de Entradas Vendidas",
                        overall: "Total",
                        totalTicketsInfo: "Los ingresos generados por las ventas de entradas para tu transmisión se acreditarán en tu billetera dentro de las 24 horas posteriores a la conclusión de la transmisión.",
                    },
                    liveEnded: {
                        title: "En Vivo Finalizado",
                        rate: {
                            options: {
                                bad: "Malo",
                                ok: "Ok",
                                good: "Bueno",
                                loveIt: "Me Encanta",
                            },
                        },
                    },
                    rules: {
                        title: "Al usar programas en vivo, aceptas nuestras ",
                        name: "reglas de transmisión",
                    },
                    streamingNow: "Transmitiendo ahora",
                    streamStartedOn: "Comenzó hace {time}",
                },
                //https://noodzly.com/user/setting/creator/subscription
                subscriptions: {
                    title: "Suscripciones",
                    message_title:"(Mensaje directo)",
                    subscription_price: "Precio de Suscripción",
                    per_month: "/Mes",
                    welcome_message: "Mensaje de Bienvenida",
                    welcome_message_rule:
                        "el mensaje de bienvenida se enviará automáticamente a los nuevos suscriptores",
                    welcome_audio_message_rule:
                        "* El mensaje de audio de bienvenida se enviará automáticamente a los nuevos suscriptores.",
                    audio_note:'Mantenga presionado el micrófono para grabar el audio.',
                    save: "Salvar",
                    subscribers: "Suscriptores",
                    saved: "¡Hecho!",
                    text_message:"Mensaje",
                    video_message:"Audio",
                    start_date:'Fecha de inicio',
                    end_date:'Fecha de finalización',
                    renewal_date:'Fecha de renovación',
                    total_earning:'Ganancias totales',
                    total_spent:'Total gastado',
                    default_active_label:'Activo',
                    subscription_default_message:'Mensaje predeterminado',
                    save_price: "Ahorrar precio",
                    save_default_message: "Guardar mensaje predeterminado",
                    save_bundles_benefits: "Paquetes de ahorro y beneficios",
                    gifted_subscription: "Dotada por {name} ({months})",
                    gifted_by: "Regalo tuyo ({months})",
                    terminated: "La suscripción se ha cancelado correctamente.",
                    free: "Gratis"
                },
                //https://noodzly.com/user/setting/creator/tips
                tip_menu: {
                    title: "Menú de Propinas",
                    sub_title_1:
                        "Añade artículos o servicios a la venta. Los compradores pueden comprarlos directamente desde tu perfil.",
                    sub_title_2:
                        "Tendrás 3 días para entregar la solicitud del comprador.",
                    enter_name: "Añadir Nombre del Artículo",
                    save: "Salvar",
                    saved: "¡Hecho!",
                    zero_price: "Si deja el precio en 0$, se mostrará como 'A pedido'",
                    on_request: "A solicitud",
                },
                // https://noodzly.com/user/setting/creator/messages
                messages: {
                    title: "Mensajes",
                    direct_messages_price: "Precio de Mensajes Directos",
                    placeholder: "0-49.99",
                    save: "SALVAR",
                    saved: "¡Hecho!",
                    price_suffix: "/Mes",
                    direct_message_info: "El usuario que no quiera suscribirse puede enviarle un mensaje pagando este precio."
                },
                referrals: {
                    title: "Referidos",
                    description:
                        "Por cada persona que se registre en Noodzly utilizando tu código de referencia, recibirás un bono equivalente al 3% de sus ganancias netas durante un período de 12 meses. Este bono se te pagará al mismo tiempo que retiren sus ganancias.",
                    code: "Código",
                    links: "Enlaces",
                    my_referrals: "Mis Referidos",
                    name: "Nombre",
                    status: "Estado",
                    date: "Fecha",
                },
                promotion: {
                    title: "Promoción",
                    description:
                        'La promoción te permite potenciar tu contenido en la sección "Descubrir" y llegar a más personas que pueden convertirse en nuevos suscriptores. Antes de iniciar tu promoción, debes tener al menos un contenido en tu historia.',
                    notags: "Por favor seleccione al menos una etiqueta",
                    countries: "Países",
                },

                holiday_mood: {
                    title: "Modo vacaciones",
                    description_title: "¿Estás esperando un descanso de Noodzly?",
                    description_details: "Activa el modo Vacaciones para pausar las suscripciones de tus suscriptores y asegurarte de que no se les cobre durante tu ausencia. Este modo se desactiva automáticamente cuando publicas contenido nuevo.",
                    description_bottom: "Si está inactivo durante 72 horas, el modo vacaciones se habilitará automáticamente.",
                    active_label: "Activar",
                },
                dream_goal: {
                    title: "Sueño",
                    description_details: "¿Hay algo grande que te gustaría tener o lograr? Ponte una meta y deja que la gente te ayude con sus contribuciones. Al activarla, tu sueño será visible para todos en tu perfil.",
                    save: "Ahorrar & Activar",
                    stop: "Detener",
                    placeholder: {
                        name: "Agregar nombre de sueño",
                        price: "Precio",
                    },
                    saved: "¡Hecho!",
                },
                moderator: {
                    title: "Moderador",
                    description_title: "¿Quieres ser moderador?",
                    description_details: "Ayúdanos a mantener Noodzly seguro y divertido para todos. ¿Ves algo que infringe nuestra política o te parece inseguro? Repórtalo.",
                    description_bottom: "Si lo eliminamos, ganarás $0,10 en créditos, directamente a tu billetera. Es así de simple: mantén las cosas limpias y obtén recompensas.",
                    apply: "Aplicar",
                    requested: "Solicitado",
                    saved: "¡Hecho!",
                    youre_moderator: "Eres moderador 👮‍♀️",
                    no_reports: "No se encontraron informes.",
                    total_earned : "Total ganado",
                    reward: "Premio",
                    rejected: "Rechazado",
                },
                mystery_box: {
                    title: "Caja Misteriosa",
                    price: "Precio",
                    total_earning: "Ganancias Totales",
                    status: "Estado",
                    heading: "Información de la Caja Misteriosa",
                    total_available: "Total de cajas disponibles",
                    description: "¿Qué hay dentro de esta caja misteriosa? ¡Despierta la curiosidad de tus fans..!",
                    prize_table: "Tabla de Premios",
                    add_prize: "Agregar Premio",
                    add_message: "Agregar hasta 10 artículos",
                    allow_multiple: "Permitir Aperturas Múltiples",
                    allow_multiple_desc: "Los usuarios pueden comprar esto varias veces",
                    box_status: "Estado de la Caja",
                    box_status_desc: "El estado de la caja misteriosa es:",
                    save: "Caja Misteriosa Activa",
                    box_price: "Precio de la Caja",
                    remaining_boxes: "Cajas Restantes",
                    possible_rewards: "Recompensas Posibles",
                    open_box: "Abrir Caja por",
                    request_prize: "Solicitar Tu Premio",
                    turn_of_box: "Desactivar Caja Misteriosa",
                    prize_sent: "Premio Enviado",
                    prize_received: "Premio Recibido?",
                    prize_message: "{user} ganó {reward}",
                    won_nothing: "¡Esta vez no ganaste nada! ¡Te deseo más suerte la próxima!",
                    you_won: "Has Ganado",
                    congratulaion_message: "¡Felicidades! Has ganado un {result} con el streamer, {name}",
                    prize_requested: "Premio Solicitado",
                }
            },
            ideas: "Ideas",
        },
        payment: {
            paypal: {
                payment_processing: "Procesamiento de pagos...",
                payment_failed: "Pago fallido",
                payment_success: "Pago realizado con éxito",
                payment_cancelled: "Pago cancelado",
            },
        },
        onboard: {
            title: "¡Un último paso!",
            gender: "¿Cómo te identificas?",
            interested_gender: "Estoy interesado en",
            age: "¿Cual es tu edad?",
            save: "Vamos",
        },
    },
    profile: {
        // https://noodzly.com/profile
        main: {
            creator: "NOODZLER",
            info: "INFORMACIÓN",
            followers: "Seguidores",
            following: "Siguiendo",
            get_app:"Obtener la aplicación",
            achievements: "LOGROS",
            top_tippers: "MEJORES DONADORES",
            no_tippers: "No hay donadores por el momento.",
            no_achievements: "No hay logros por el momento.",
        },
        // https://noodzly.com/profile/info
        info: {
            title: "Información",
            type_your_bio: "Tu Biografía",
            amazon_url: "URL de Amazon",
            instagram_url: "URL de Instagram",
            twitter_url: "URL de X",
            my_age: "Mi Edad",
            i_am: "Mi sexo",
            male: "Hombre",
            female: "Mujer",
            transgender: "Transgénero",
            categories: "Categorías",
            show_achievements: "Mostrar Logros",
            show_achievements_desc: "Muestra a los demás tu insignia de logros",
            show_top_tippers: "Mostrar Mejores Donadores",
            show_top_tippers_desc: "Muestra a los demás tus mejores donadores",
            my_countries: "Mi país",
            countries: "País",
            online_status: "Estado en Línea",
            online_status_desc: "Muestra a los demás cuando estás en línea",
        },
        wallet: {
            // https://noodzly.com/profile/wallet
            withdraw: {
                available_balance: "Saldo Disponible",
                total_net: "Total Neto",
                total_gross: "Total Bruto",
                total_net_info:
                    "El {netfee}% de las tarifas se utiliza para cubrir los costos de procesamiento de pagos, pagos de referencia, alojamiento, soporte y todos los demás servicios de Noodzly.",
                bank_transfer: "Transferencia Bancaria",
                bitsafe: "Yoursafe",
                wire_transfer: "Transferencia bancaria internacional",
                crypto_wallet: "Cripto",
                noodzly_fee: "Tarifa de Noodzly",
                additional_fee: "Tarifa bancaria",
                additinal_fee_info: "La tarifa bancaria se utiliza para cubrir el procesamiento del pago.",
                withdraw_btn: 'Retirar',
            },
        },
        stream: {
            header: "Transmisiones de ",
            title: "Próxima Transmisión Privada",
            purchaseTicket: "Comprar Entrada",
            startWatching: "Empezar a Ver",
            streamingNow: "Transmitiendo ahora",
            streamStartedOn: "Comenzó hace {time}",
        },
        streams: {
            rating: {
                title: "Calificación de Transmisiones",
                stats: {
                    streams: "Vidas",
                    min: "min",
                    averageDuration: "Duración Media",
                },
            },
        },
    },
    // https://noodzly.com/search
    search: {
        placeholder: "Buscar",
    },
    messages: {
        title: "Mensajes",
        search: "Buscar",
        turn_off_direct_messages: "Desactivar mensajes directos",
    },
    channels: {
        title: "Transmisiones",
        yourChannel: "Tu transmisión",
        description: {
            forEveryone:
                "La transmisión es una forma de recibir mensajes de tus Fideos para estar actualizados sobre lo próximo que hagan!",
            forCreators:
                "¡La transmisión te permite enviar mensajes solo a tus suscriptores para mantenerlos informados sobre tu próxima novedad!",
        },
        other_user_broadcast: "Transmisión de {user_name}",
        pinned_message: "Mensaje fijado",
    },
    email_verify: {
        title: "Verificar Correo Electrónico",
        almost_there: "¡Casi Estás!",
        before_link: "Hola {user}, enviamos un correo de confirmación a",
        change: "(Cambiar)",
        after_link: "para empezar, confirma tu correo electrónico.",
        button: "REENVIAR CORREO",
    },
    privacy: {
        title: "Política de Privacidad",
        desc_1: "Al utilizar los servicios de Noodzly.com, aceptas el uso de nuestras cookies. Utilizamos cookies con fines que incluyen análisis, personalización y publicidad.",
        desc_2: "Esta página y algunas otras en este sitio colocan y leen cookies de terceros en tu navegador, que se utilizan con fines no esenciales. A través de estas cookies, nuestros socios recopilan datos personales sobre ti para sus propios fines.",
    },
    home: {
        desktop_description:
            "Noodzly te permite compartir tu contenido amateur de forma totalmente anónima mientras recibes pago, y todo el contenido se eliminará después de 24 horas.",
        qr_code_text: "Escanear el código QR",
        qr_code_sub_text: "Mejor en tu smartphone",
                hero_content: {
            title: "Send nudes. Get paid.",
            description: "Or don't. Just be you — explore, have fun, and connect. Noodzly is your playful space to express yourself and (if you feel like it) make money. All on your own terms.",
            cta_1: "Try Noodzly Now",
            cta_2: "Login",
            stats_1: "Active Creators",
            stats_2: "Creator Earnings",
            stats_3: "Happy Users",
        },
        hero_block_img: {
            text_1: "Scan the QR code",
            text_2: "and try it from your phone.",
        },
        about_us: {
            title: "What's",
            title_highlight: "Noodzly?",
            description: "Noodzly is a real-time space where you can share amateur photos, videos, or go live. Your fans can subscribe, tip, or unlock exclusive content — totally on your terms. Just a safe, anonymous, and fun space for creators and fans to connect.",
            cta: "Let's Get Noodz 👀",
            features: {
                photo_video: {
                    alt: "photo video",
                    title: "Photo & Video",
                    subtitle: "Share your moments"
                },
                live_streams: {
                    alt: "Live Streams",
                    title: "Live Streams",
                    subtitle: "Go live anytime"
                },
                income_streams: {
                    alt: "Multiple Income Streams",
                    title: "Multiple Income Streams",
                    subtitle: "Subscriptions, tips & more"
                },
                auto_delete: {
                    alt: "24h auto delete",
                    title: "24h Auto-Delete",
                    subtitle: "Content vanishes automatically"
                },
            },
        },
        creator_benefits: {
            title_part1: "Benefits for",
            title_part2: "Creators",
            subtitle: "Snap it. Post it. Earn from it.",
            better_title: "And it gets better:",
            cta_button: "Join the Fun 🎉",
            subscriptions: {
                alt: "Subscriptions",
                title: "Subscriptions"
            },
            photo_video: {
                alt: "photo & video",
                title: "Photo & video"
            },
            pay_per_view: {
                alt: "Pay Per View Content",
                title: "Pay-per-view content"
            },
            private_streams: {
                alt: "Private Streams",
                title: "Private streams"
            },
            tips: {
                alt: "Tips",
                title: "Tips"
            },
            private_requests: {
                alt: "Private Requests",
                title: "Private requests"
            },
            referral_program: {
                alt: "Referral Program",
                title: "Referral program"
            },
            and_more: {
                alt: "And Much More Icon",
                title: "And much more!"
            },
            better_features: {
                live_solo: {
                    alt: "Subscriptions",
                    text: "Go live solo — or with another creator"
                },
                holiday_mode: {
                    alt: "photo & video",
                    text: "Pause everything anytime with \"Holiday Mode\" on your break"
                },
                privacy_controls: {
                    alt: "Pay Per View Content",
                    text: "Full privacy controls: choose who can see your profile"
                },
                disappearing_content: {
                    alt: "Private Streams",
                    text: "Share content that disappears after 24h"
                },
                fast_payouts: {
                    alt: "Tips",
                    text: "Fast and easy payouts"
                }
            },
        },
        fan_benefits: {
            title_part1: "Benefits for",
            title_part2: "Fans",
            subtitle: "Chill. Explore. Support.",
            cta_button: "Start Exploring 🔥",
            discover_content: {
                alt: "Discover Real Unfiltered Content",
                title: "Discover real, unfiltered content"
            },
            real_time: {
                alt: "Real Time People and Moments",
                title: "Real-time people and moments"
            },
            subscribe: {
                alt: "Subscribe To Your Favorite Creators",
                title: "Subscribe to your favorite creators"
            },
            tips_requests: {
                alt: "Send Tips Or Request Something Personal",
                title: "Send tips or request something personal"
            },
            easy_signup: {
                alt: "sign up With Just an Email and Password",
                title: "Sign up with just an email and password"
            },
            wallet: {
                alt: "In App Wallet To Support Your Faves",
                title: "In-app wallet to support your faves"
            }
        },
        safety: {
            title: "Safety first —",
            title_highlight: "Always",
            subtitle: "Your safety is our priority. We've built Noodzly to be a safe, trusted space.",
            trusted_space: {
                heading: "We've built Noodzly to be a safe, trusted space.",
                creators_verified: "All creators are verified",
                profile_control: "Full control over your profile visibility",
                auto_delete: "All content auto-deletes in 24h",
                secure_payments: "Payments stay inside the app with our secure wallet system",
                image_alt: "Built Noodzly To be a Safe Trusted Space"
            },
            protection: {
                heading: "Protection that matters",
                description: "We take your privacy seriously. Your data and content are fully protected and the content deleted automatically. We comply with all industry standards.",
                image_alt: "Protection That Matters"
            },
            support: {
                heading_one: "Need help?",
                heading_two: "Real humans, 24/7",
                description: "Our support team is always here to help — fast, friendly, and ready when you need us.",
                image_alt: "Need help? Real humans, 24/7"
            }
        },
        cta: {
            title: "Ready to become a Noodzler?",
            subtitle: "Whether you're here to post or just peek, there's a place for you.",
            description: "Try it now from your phone. Scan the QR code and have fun 🧡",
            qr_alt: "scan QR code"
        },
        footer_block: {
            title: "Explore, have fun, and connect",
        },
        choose_noodzly: {
            title_part1: "Por qué las creadoras y las fans eligen",
            title_part2: "Noodzly",
            cta_button: "¡Únete a Noodzly ahora! 🔥"
        }
    },
    // https://noodzly.com/user/5/tips
    user_tips: {
        title: "Menú de Propinas de {name}",
        subtitle: "Artículos o servicios en venta por {name}",
        zero_price_text: "¿Quieres solicitar {item_name}?",
        buy_item_text: "¿Quieres comprar {tip_name} por {tip_price}$?",
    },
    copyright: "&copy;{year} Noodzly. Reservados todos los derechos.",
    other_user: {
        labels: {
            icons: {
                message: "Mensaje",
                menu: "Menú",
                tip: "Consejo",
                live: "Vivir",
                dream: "Sueño",
            },
        },
    },
    sign_up: {
        age_confirmation: "Confirmo que tengo al menos 18 años",
        term_condition: "Confirmo que he leído y acepto los términos y condiciones",
        content_acknowledge: "Reconozco y acepto que mis imágenes y contenido pueden ser utilizados y mostrados públicamente en Noodzly.",
        provider_agreement: "Confirmo que he leído y acepto los términos y condiciones",
    }
};
